import { useState, useEffect, RefObject } from 'react'

type Position = { top: number; left: number }

type UseDialogPositionOptions = {
  dialogRef: RefObject<HTMLDivElement | null>
  anchorRect?: DOMRect
  offset?: number
  viewportPadding?: number
}

export const useDialogPosition = ({
  dialogRef,
  anchorRect,
  offset = 8,
  viewportPadding = 16,
}: UseDialogPositionOptions): Position => {
  const [position, setPosition] = useState<Position>({ top: 0, left: 0 })

  useEffect(() => {
    if (!anchorRect || !dialogRef.current) return

    const dialogRect = dialogRef.current.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const viewportWidth = window.innerWidth

    let top = anchorRect.bottom + offset
    let left = anchorRect.left

    if (top + dialogRect.height > viewportHeight) {
      top = anchorRect.top - dialogRect.height - offset
    }

    if (left + dialogRect.width > viewportWidth) {
      left = viewportWidth - dialogRect.width - viewportPadding
    }

    setPosition({ top, left })
  }, [anchorRect, dialogRef, offset, viewportPadding])

  return position
}
